export default "__VITE_ASSET__EQtPnoJ___"